import React,{useState,useEffect} from 'react'
import VendorsMonthlyData from './vendorsMonthlyData'
import YearlyMonthlydata from './yearlyMonthlydata';
import api from '../../../../Services/api';
import Snackbar from '@mui/material/Snackbar';
import SnackbarContent from '@mui/material/SnackbarContent';
import ReportSection from './reportSection';
import { Link, useNavigate } from "react-router-dom";
import { FaBuilding, FaUserTie } from "react-icons/fa";







export default function Index() {

  const navigate = useNavigate();

  let data1 = sessionStorage.getItem('user');
  let clientData = JSON.parse(data1);
  let id = clientData.id;
  const [vendors,setVendors] = useState([])
  const [loading, setLoading] = useState(true);
      const [snackbarOpen, setSnackbarOpen] = useState(false);
                const [snackbarMessage, setSnackbarMessage] = useState('');
                const [errorSnackbarOpen, setErrorSnackbarOpen] = useState(false);
                const [snackbarErrorMessage, setSnackbarErrorMessage] = useState('');
      
  const [activeDashboard, setActiveDashboard] = useState("vendor");
  


  useEffect(() => {
     const timer = setTimeout(() => {
       fetchVendors();
     }, 1000); 
   
     return () => clearTimeout(timer); 
   }, [id]);


   const fetchVendors = async () => {
        try {
        const response = await api.client.getAllVendors(id);
     
        if(response.status === 200){
        setVendors(response.data.data.vendorProfile || []);
      
        }
        else if(response.status === 404){
          setErrorSnackbarOpen(true)
          setSnackbarErrorMessage(response.data.message);
          setVendors( []);
        }
        else if(response.status === 400){
          setErrorSnackbarOpen(true)
          setSnackbarErrorMessage(response.data.message);
          setVendors([]);
      
        }
    }
    catch(error) {
        console.error("Error in fetching the data",error);
        setVendors([]); 
    }
    finally {
      setLoading(false); 
    }
}
const handleClickEstablishment =()=>{
  setActiveDashboard('establishment')
   navigate('/establishmentdashboard')
}
const handleClickVendor =()=>{
  setActiveDashboard('vendor')
  navigate('/establishmentVendordashboard')
}

  return (
    <div>
          <Snackbar
                          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                          severity="success"
                          open={snackbarOpen}
                          autoHideDuration={2000}
                          onClose={() => setSnackbarOpen(false)}
                          sx={{ marginTop: '2.9%', marginRight: '7%' }}
                        >
                          <SnackbarContent style={{ backgroundColor: "green" }} message={snackbarMessage} />
                        </Snackbar>
                        <Snackbar
                          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                          severity="error"
                          open={errorSnackbarOpen}
                          autoHideDuration={2000}
                          sx={{ marginTop: '2.9%', marginRight: '7%' }}
                          onClose={() => setErrorSnackbarOpen(false)}
                        >
                          <SnackbarContent style={{ backgroundColor: "red" }} message={snackbarErrorMessage} />
                        </Snackbar>
                          <section
  className="d-flex justify-content-between align-items-center px-4 py-2"
  
>
  {/* Left side: Legend */}
  <div className="d-flex align-items-center" style={{ letterSpacing: "1px" }}>
    <div
      style={{
        backgroundColor: "#50c878",
        width: "15px",
        height: "15px",
        display: "inline-block",
        marginRight: "4px",
        borderRadius: "50%",
      }}
    ></div>
    <span style={{ fontSize: "14px" }}>Accepted</span>

    <div className="vr mx-3"></div>

    <div
      style={{
        backgroundColor: "#B22222",
        width: "15px",
        height: "15px",
        display: "inline-block",
        marginRight: "4px",
        borderRadius: "50%",
      }}
    ></div>
    <span style={{ fontSize: "14px" }}>Rejected</span>

    <div className="vr mx-3"></div>

    <div
      style={{
        backgroundColor: "#EFCC00",
        width: "15px",
        height: "15px",
        display: "inline-block",
        marginRight: "4px",
        marginLeft: "8px",
        borderRadius: "50%",
      }}
    ></div>
    <span style={{ fontSize: "14px" }}>Under review</span>

    <div className="vr mx-3"></div>

    <div
      style={{
        backgroundColor: "lightgray",
        width: "15px",
        height: "15px",
        display: "inline-block",
        marginRight: "4px",
        borderRadius: "50%",
      }}
    ></div>
    <span style={{ fontSize: "14px" }}>Not Uploaded</span>
  </div>

  <div className="flex gap-2">
  <button
    title="Establishment Compliance"
    onClick={handleClickEstablishment}
    className={`flex items-center gap-2 px-3 py-2 rounded-full transition-all duration-300 cursor-pointer
      ${activeDashboard === 'establishment' 
        ? 'bg-success text-white opacity-70' 
        : 'bg-success text-white hover:px-5'}`}
    disabled={activeDashboard === 'establishment'}
  >
    <FaBuilding />
    {activeDashboard === 'establishment' && (
      <span>Establishment Compliance</span>
    )}
  </button>

  <button
    title="Vendor Compliance"
    onClick={handleClickVendor}
    className={`flex items-center gap-2 px-3 py-2 rounded-full transition-all duration-300 cursor-pointer
      ${activeDashboard === 'vendor' 
        ? 'bg-danger text-white opacity-70' 
        : 'bg-danger text-white hover:px-5'}`}
    disabled={activeDashboard === 'vendor'}
  >
    <FaUserTie />
    {activeDashboard === 'vendor' && (
      <span>Vendor Compliance</span>
    )}
  </button>
</div>

</section>
        {loading ? (
              <div className="d-flex flex-row align-items-center justify-content-center" style={{ marginTop: '80px' }}>
              <h3>Loading</h3>
     <div className="spinner-grow text-danger" style={{ width: '1rem', height: '1rem' ,marginLeft:'10px'}} role="status"></div> 
     <div className="spinner-grow text-danger" style={{ width: '1rem', height: '1rem' ,marginLeft:'10px'}} role="status"></div>
     <div className="spinner-grow text-danger" style={{ width: '1rem', height: '1rem' ,marginLeft:'10px'}} role="status"></div>
     
     </div>
              ) : 
    vendors.length > 0 ? (
    <>
 

    <div  className="mx-4" style={{ display: 'grid',gridTemplateColumns: '0.6fr 1fr 0.6fr',gridTemplateRows: '0fr 0fr', gap: '10px' }}>
     
      <YearlyMonthlydata show="donut"/>

      <VendorsMonthlyData/>
      <ReportSection/>
      <div style={{ gridColumn: '1 / span 3' }}>

      <YearlyMonthlydata show="bar"/>
      </div>
    </div>
    </>
    ) : (
<div>
  <p className="text-danger text-center p-5">No Vendor Found!!</p>
</div>

    )}
    </div>
  )

}
